import React from 'react'; import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { Helmet } from 'react-helmet';
import { getTrafficDetail } from '../../actions.js';
import { addLoading, removeLoading } from '../../../ui/src/actions.js';
import { Comments } from '../../../ui/src/component/facebook';
import { Icon } from '../../../ui/src/component/icon';
import { CsmArticleMeta } from '../../../ui/src/component/csmArticle';
import { Spinner } from '../../../ui/src/component/spinner';
import { TrafficItem } from '../../component/trafficItem/';
import {
  getIconForCategory,
  getTrafficGalleryImageBaseUrl,
} from '../../component/trafficItem/trafficItem';
import { TrafficGoogleMap } from '../../component/trafficGoogleMap';
import { Photogallery } from '../../../ui/src/component/photogallery';
import Api from '../../../ui/src/api.js';
import { getProp } from '../../../ui/src/utilities';

class TrafficDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      closeTraffic: [],
      closeTrafficFetching: false,
    };
  }

  componentDidMount() {
    TrafficDetail.init(this.props.dispatch, this.props.params);
    const detail = this.getDetail();
    if (detail) {
      this.fetchClose();
    }
  }

  static init(dispatch, params) {
    return dispatch(getTrafficDetail(params.id));
  }

  componentWillReceiveProps(nextProps) {
    this.props.dispatch(getTrafficDetail(nextProps.params.id)).then(() => {
      const detail = this.getDetail(nextProps.params.id);
      if (detail) {
        if (nextProps.params.id !== this.state.id) {
          this.fetchClose(nextProps.params.id);
          this.setState({ id: nextProps.params.id });
        }
      }
    });
  }

  fetchClose(id = this.props.params.id) {
    const detail = this.getDetail();
    if (detail) {
      this.props.dispatch(addLoading());
      this.setState({ closeTrafficFetching: true });
      Api.get(`/traffic/location`, {
        location: `${getProp(detail, 'location.lon', 0)},${getProp(
          detail,
          'location.lat',
          0,
        )}`,
        distance: 1000,
        exclude: id,
      })
        .then(response => {
          this.props.dispatch(removeLoading());
          this.setState({
            closeTraffic: response.traffic,
            closeTrafficFetching: false,
          });
        })
        .catch(err => {
          console.error(err);
          this.props.dispatch(removeLoading());
          this.setState({ closeTrafficFetching: false });
        });
    }
  }

  getDetail(id = this.props.params.id) {
    return this.props.entities[id];
  }

  renderDetail(detail) {
    const images = getProp(detail, 'imageobjects', []);
    const canonicalUrl = `${
      process.env.REACT_APP_API_BASE_URL
    }/dopravny-servis/${detail._id}`;
    // const items = [...this.state.closeTraffic, detail];
    // len jeden market zobrazujeme (poziadavka zakaznika 21.8.2017)
    // TODO: preblikava ina ikonka ked preklikavam medzi Prehľad udalostí v tejto lokalite
    // TODO: Blbne este nextOffset - miesa sa clankami
    const items = [detail];

    return (
      <div className="traffic-detail">
        <Helmet>
          <title>{detail.title}</title>
          <meta property="og:title" content={detail.title} />
          <meta property="og:type" content="article" />
          <meta property="og:url" content={canonicalUrl} />
        </Helmet>
        <div className="bg-alt-light article-header">
          <div className="container header-container">
            <div className="article-header-title clearfix">
              <h1>
                <Link to="/dopravny-servis" className="link-back">
                  <Icon name="chevron-circle-right" />
                </Link>
                <span className="title-text">{detail.title}</span>
                <img
                  className="category-icon"
                  src={getIconForCategory(detail.category)}
                  alt=""
                />
              </h1>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="section">
            <div className="row">
              <div className="col-sm-12 col-md-9">
                <Spinner show={this.state.closeTrafficFetching}>
                  <TrafficGoogleMap
                    markers={items.map(item => {
                      return item;
                    })}
                    onClickDetail={id => {
                      this.props.dispatch(push(`/dopravny-servis/${id}`));
                    }}
                    activeMarkerId={detail._id}
                  />

                  <article className="article-container section">
                    <CsmArticleMeta
                      creationDate={detail.created_date}
                      authorName={`${getProp(
                        detail,
                        'user.firstname',
                      )} ${getProp(detail, 'user.surname')}`}
                      allowShare={false}
                    />
                    {detail.description ? (
                      <p>
                        <strong>{detail.description}</strong>
                      </p>
                    ) : (
                      <p>
                        <em>Udalosť bez popisu</em>
                      </p>
                    )}
                    {images.length > 0 && (
                      <div>
                        <h2>Priložené fotografie</h2>
                        <Photogallery
                          photos={images.map(item => {
                            return {
                              uri: item.path,
                              name: item.description,
                            };
                          })}
                          imageBaseUrl={getTrafficGalleryImageBaseUrl()}
                        />
                      </div>
                    )}
                    {detail.path && (
                      <div>
                        <h2>Priložené video</h2>
                        <div className="text-center">
                          <div
                            className="thumbnail"
                            style={{
                              display: 'inline-block',
                              padding: 0,
                              fontSize: 0,
                              background: '#000',
                            }}
                          >
                            <video
                              style={{
                                width: '500px',
                                maxHeight: '500px',
                              }}
                              controls
                            >
                              <source
                                src={`https://data.tvkosice.sk/userdata/${
                                  detail.path
                                }`}
                                type="video/mp4"
                              />
                            </video>
                          </div>
                        </div>
                      </div>
                    )}
                    <div>
                      <h3 className="h2">Komentáre</h3>
                      <Comments canonicalUrl={canonicalUrl} />
                    </div>
                  </article>
                </Spinner>
              </div>
              {this.state.closeTraffic.length > 0 && (
                <div className="close-traffic-sidebar col-sm-12 col-md-3">
                  <h3>Prehľad udalostí v tejto lokalite</h3>
                  <Spinner show={this.state.closeTrafficFetching}>
                    <div className="row">
                      {this.state.closeTraffic.map(item => {
                        return (
                          <div
                            key={item._id}
                            className="col-xs-12 col-sm-6 col-md-12"
                          >
                            <TrafficItem item={item} />
                          </div>
                        );
                      })}
                    </div>
                  </Spinner>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const detail = this.getDetail();
    if (detail) {
      return this.renderDetail(detail);
    } else {
      return <Spinner show={true} />;
    }
  }
}

TrafficDetail.fetchData = ({ store, params }) => {
  return TrafficDetail.init(store.dispatch, params);
};

TrafficDetail.propTypes = {
  dispatch: PropTypes.func.isRequired,
  entities: PropTypes.object,
  params: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    entities: state.trafficEntities.byId,
  };
};

export default connect(mapStateToProps)(TrafficDetail);



// WEBPACK FOOTER //
// ./src/app/container/traffic/detail.js